module.exports = __webpack_public_path__ + "fonts/Averta-Bold.168837a.woff2";